import { z } from 'zod';
import { allAmounts, categoriseAmount, constDate, describeAmount, once, scaleAmount, taxonomyRefSchema, unit, } from './payments/payments.js';
export const oneTimeInvoiceLineSpecSchema = z.object({
    description: z.string(),
    amount: z.number().positive(),
    taxonomy: taxonomyRefSchema.optional(),
});
export function lineAmount(line) {
    const amount = scaleAmount(line.amount, unit());
    return line.taxonomy === undefined
        ? describeAmount(line.description, amount)
        : categoriseAmount(line.taxonomy, line.description, amount);
}
export function buildOneTimeOnceSpec(dueDate, lines, currency = 'USD') {
    if (lines.length === 0) {
        throw new Error('buildOneTimeOnceSpec requires at least one line');
    }
    const amounts = lines.map((line) => lineAmount(line));
    return once(constDate(dueDate), allAmounts(...amounts), currency);
}
export const qboInvoicePhaseSchema = z.discriminatedUnion('status', [
    z.object({ status: z.literal('created'), externalId: z.string() }),
    z.object({ status: z.literal('failed'), error: z.string() }),
]);
export const payabliLinkPhaseSchema = z.discriminatedUnion('status', [
    z.object({ status: z.literal('attached') }),
    z.object({ status: z.literal('skipped'), reason: z.string() }),
    z.object({ status: z.literal('not-attempted') }),
    z.object({ status: z.literal('failed'), error: z.string() }),
]);
export const emailPhaseSchema = z.discriminatedUnion('status', [
    z.object({ status: z.literal('sent'), warning: z.string().optional() }),
    z.object({ status: z.literal('skipped'), reason: z.string() }),
    z.object({ status: z.literal('failed'), error: z.string() }),
]);
export const createOneTimeInvoiceResultSchema = z.object({
    occurrenceDisplayId: z.string(),
    invoiceNumber: z.string(),
    qboInvoice: qboInvoicePhaseSchema,
    payabliLink: payabliLinkPhaseSchema,
    email: emailPhaseSchema,
});
//# sourceMappingURL=oneTimeInvoice.js.map